import axios from "axios";
import moment from "moment-timezone";

const API = axios.create();
API.defaults.headers.common["Accept"] = "application/json";
API.defaults.headers.common["Content-Type"] = "application/json";
API.defaults.headers.common["Timezone"] = moment.tz.guess();

let apiPrefix = "/api/v1";

const API_ROUTES = {
    ADMIN_ACTIVITY_CHECKLISTS: `${apiPrefix}/admin/activity-checklists`,
    ADMIN_AI_USAGE: `${apiPrefix}/admin/ai-usage`,
    CSRF_COOKIE: "/sanctum/csrf-cookie",
    LOGIN: `${apiPrefix}/auth/login`,
    LOGIN_AUTH0: `${apiPrefix}/auth/loginAuth0`,
    LOGOUT: `${apiPrefix}/auth/logout`,
    LOGOUT_AUTH0: `${apiPrefix}/auth/logoutAuth0`,
    VALIDATE_REGISTER_SECTION: `${apiPrefix}/auth/validate-register-section`,
    REGISTER: `${apiPrefix}/auth/register`,
    REGISTER_AUTH0: `${apiPrefix}/auth/registerAuth0`,
    FORGOT_PASSWORD: `${apiPrefix}/auth/forgot-password`,
    RESET_PASSWORD: `${apiPrefix}/auth/reset-password`,
    CURRENT_USER: `${apiPrefix}/current-user`,
    USERS_APPLY: `${apiPrefix}/users/apply`,
    TAXONOMY_CATEGORY_TYPES: `${apiPrefix}/category-types`,
    TAXONOMY_CATEGORIES: `${apiPrefix}/categories`,
    TAXONOMY_SUBCATEGORIES: `${apiPrefix}/subcategories`,
    TAXONOMY_STRAIN_TYPES: `${apiPrefix}/strain-types`,
    TAXONOMY_STRAINS: `${apiPrefix}/strains`,
    TAXONOMY_STRAINS_METRC: `${apiPrefix}/strains-metrc`,
    TAXONOMY_PRODUCTION_TYPES: `${apiPrefix}/production-types`,
    ADMIN_UNIVERSAL_DIRECTORY: `${apiPrefix}/admin/universal-directory`,
    ADMIN_USERS: `${apiPrefix}/admin/users`,
    ADMIN_USER_ROLES: `${apiPrefix}/admin/users/roles`,
    ADMIN_APPLICATIONS: `${apiPrefix}/admin/applications`,
    ADMIN_COMPANIES: `${apiPrefix}/admin/companies`,
    ADMIN_COMPANY_STATUSES: `${apiPrefix}/admin/companies/statuses`,
    ADMIN_LICENSES: `${apiPrefix}/admin/licenses`,
    ADMIN_LICENSE_TYPES: `${apiPrefix}/admin/licenses/types`,
    ADMIN_LISTINGS: `${apiPrefix}/admin/listings`,
    ADMIN_LISTING_STATUSES: `${apiPrefix}/admin/listings/statuses`,
    ADMIN_ORDERS: `${apiPrefix}/admin/orders`,
    ADMIN_ORDER_STATUSES: `${apiPrefix}/admin/orders/statuses`,
    ADMIN_ORDER_TYPES: `${apiPrefix}/admin/orders/types`,
    ADMIN_ORDER_SOURCES: `${apiPrefix}/admin/orders/sources`,
    ADMIN_TAXONOMY_BRANDS: `${apiPrefix}/admin/taxonomies/brands`,
    ADMIN_TAXONOMY_CATEGORY_TYPES: `${apiPrefix}/admin/taxonomies/category-types`,
    ADMIN_TAXONOMY_CATEGORIES: `${apiPrefix}/admin/taxonomies/categories`,
    ADMIN_TAXONOMY_SUBCATEGORIES: `${apiPrefix}/admin/taxonomies/subcategories`,
    ADMIN_TAXONOMY_PRODUCTION_TYPES: `${apiPrefix}/admin/taxonomies/production-types`,
    ADMIN_TAXONOMY_STRAIN_TYPES: `${apiPrefix}/admin/taxonomies/strain-types`,
    ADMIN_TAXONOMY_STRAINS: `${apiPrefix}/admin/taxonomies/strains`,
    ADMIN_TAXONOMY_CATEGORY_IMAGES: `${apiPrefix}/admin/taxonomies/category-images`,
    ADMIN_NON_METRC_TAXONOMY_CATEGORIES: `${apiPrefix}/admin/non-metrc-taxonomy/categories`,
    ADMIN_NON_METRC_TAXONOMY_FACET_VALUES: `${apiPrefix}/admin/non-metrc-taxonomy/facet-values`,
    ADMIN_NON_METRC_TAXONOMY_BROWSE_GROUPS: `${apiPrefix}/admin/non-metrc-taxonomy/browse-groups`,
    ADMIN_SHIPPERS: `${apiPrefix}/admin/shipping/shippers`,
    ADMIN_SHIPPER_PRICES: `${apiPrefix}/admin/shipping/shippers/prices`,
    ADMIN_REPORT_SALES_BY_DATE: `${apiPrefix}/admin/reports/sales-by-date`,
    ADMIN_REPORT_NEW_REPEAT_ORDERS: `${apiPrefix}/admin/reports/new-repeat-orders`,
    ADMIN_REPORT_SALES_BY_CATEGORY: `${apiPrefix}/admin/reports/sales-by-category`,
    ADMIN_REPORT_SELLERS_BY_DATE: `${apiPrefix}/admin/reports/sellers-by-date`,
    ADMIN_REPORT_SELLERS_ACTIVITY: `${apiPrefix}/admin/reports/sellers-activity`,
    ADMIN_REPORT_SELLERS_INVENTORY_COVERAGE: `${apiPrefix}/admin/reports/sellers-inventory-coverage`,
    ADMIN_REPORT_BUYERS_ACTIVITY: `${apiPrefix}/admin/reports/buyers-activity`,
    ADMIN_REPORT_BUYERS_BY_DATE: `${apiPrefix}/admin/reports/buyers-by-date`,
    ADMIN_REPORT_BRANDS_HEALTH_SCORING: `${apiPrefix}/admin/reports/brands-health-scoring`,
    ADMIN_REPORT_ACCOUNT_BILLING_STATUS: `${apiPrefix}/admin/reports/account-billing-status`,
    ADMIN_REPORT_ACCOUNT_MONTHLY_REVENUE: `${apiPrefix}/admin/reports/account-monthly-revenue`,
    ADMIN_REPORT_INCOMPLETE_APPLICATIONS: `${apiPrefix}/admin/reports/incomplete-applications`,
    ADMIN_REPORT_PUBLIC_MENU_SHARING: `${apiPrefix}/admin/reports/public-menu-sharing`,
    ADMIN_PRICE_LIMITS: `${apiPrefix}/admin/settings/price-limits`,
    ADMIN_PAYMENT_METHOD_SETTINGS: `${apiPrefix}/admin/settings/payment-methods`,
    ADMIN_PRICING_PLANS: `${apiPrefix}/admin/pricing-plans`,
    ADMIN_BILLING: `${apiPrefix}/admin/billing`,
    ADMIN_STATE_LICENSES: `${apiPrefix}/admin/state-licenses`,
    ADMIN_LICENSE_REGISTRY_LOOKUP: `${apiPrefix}/admin/license-registry/lookup`,
    ADMIN_LICENSE_REGISTRY_LICENSES: `${apiPrefix}/admin/license-registry/licenses`,
    ADMIN_LICENSE_REGISTRY_IMPORTS: `${apiPrefix}/admin/license-registry/imports`,
    ADMIN_LICENSE_REGISTRY_METADATA: `${apiPrefix}/admin/license-registry/metadata`,
    ADMIN_LICENSE_REGISTRY_CONFLICTS: `${apiPrefix}/admin/license-registry/conflicts`,
    ADMIN_LICENSE_REGISTRY_ENTITIES: `${apiPrefix}/admin/license-registry/entities`,
    ADMIN_GENERATE_MARKETING_EMAIL: `${apiPrefix}/admin/brands/create-storefronts-email-draft`,
    ADMIN_CTS_WEEKLY_SCHEDULE_IMPORT: `${apiPrefix}/cts/weekly-route-assignments/import`,
    ADMIN_CTS_FLEET_IMPORT: `${apiPrefix}/cts/fleet/import`,
    ADMIN_REPORT_WOW_ORDER_VOLUME_CHANGE: `${apiPrefix}/admin/reports/wow-order-volume-change`,
    ADMIN_REPORT_ORDER_SOURCE_MIX: `${apiPrefix}/admin/reports/order-source-mix`,
    ADMIN_REPORT_LAST_ORDER_DATE: `${apiPrefix}/admin/reports/last-order-date`,
    ADMIN_REPORT_TIME_TO_FIRST_VALUE: `${apiPrefix}/admin/reports/time-to-first-value`,
    ADMIN_REPORT_MULTI_USER_ENGAGEMENT: `${apiPrefix}/admin/reports/multi-user-engagement`,
    ADMIN_REPORT_FEATURE_ADOPTION_BREADTH: `${apiPrefix}/admin/reports/feature-adoption-breadth`,
    ADMIN_REPORT_ORDER_VALUE_TRAJECTORY: `${apiPrefix}/admin/reports/order-value-trajectory`,
    ADMIN_REPORT_PDF_EXPORT: `${apiPrefix}/admin/reports/performance-and-alerts-pdf-export`,
    ADMIN_PERMISSIONS: `${apiPrefix}/admin/permissions`,
    ADMIN_APP_NOTIFICATIONS: `${apiPrefix}/admin/app-notifications`,
}

export { API, API_ROUTES };
